import "./Faqs.module.css";
import Header from "@/reusable_sections/Header";
import ResourcesHero from "./sections/ResourcesHero";
import ContactPrompt from "./sections/ContactPrompt";
import Footer from "@/reusable_sections/Footer";
import Faq from "./sections/Faq";
export default function FaqsPage() {
  return <div>
      <Header />
      <ResourcesHero />
      <Faq />
      <ContactPrompt />
      <Footer />
    </div>;
}